import { dataProvider } from "data";
import { apiMethods } from "data/api.constants";
import { EXLY_CONNECT_APIS } from "features/ExlyConnect/ExlyConnect.api";
import constants from "constants/constants";
import { getWebinarHostJoiningLink } from "features/ExlyConnect/ExlyConnect.utils";

export const broadcastMeetingLinkApi = (slotUuid, zoomLink) => {
  return dataProvider.custom_request(
    EXLY_CONNECT_APIS.broadcast_exly_con_reminders,
    apiMethods.GET,
    { slot_uuid: slotUuid, zoom_link: zoomLink }
  );
};

export const getJoiningLink = (address_type, joining_link, slot_uuid) => {
  if (
    address_type === constants.address_type_enum.exly_zoom_webinar ||
    address_type === constants.address_type_enum.exly_connect_by_zoom
  ) {
    const finalLink = getWebinarHostJoiningLink(joining_link, slot_uuid);
    return finalLink;
  } else {
    return joining_link;
  }
};
